<template>
  <div class="text-center app-footer">
    <template v-if="state === 'NSW'">
      © {{ year }} Australian Medical Association (NSW) Ltd &nbsp;&nbsp;
      <span>||</span>
      &nbsp;&nbsp; ABN 81 000 001 614 &nbsp;&nbsp; 
    </template>
    <template v-else>
      © {{ year }} Australian Medical Association Limited &nbsp;&nbsp;
      <span>||</span>
      &nbsp;&nbsp; ABN 37 008 426 793 &nbsp;&nbsp;  
    </template>
    <span>||</span>
    &nbsp;&nbsp; <a href="/privacy-policy" target="_blank">Privacy Policy</a>&nbsp;&nbsp; 
    <template v-if="!retain">
      <span>||</span>
      &nbsp;&nbsp; <a href="/mp-terms-of-access-and-use" target="_blank">Terms of Access</a>
    </template>
  </div>
</template>
<script>
import { store } from "@/store";
export default {
  name: 'CopyrightFooter',
  data() {
    return {
      state: store.state,
      retain: store.retain,
      year: new Date().getFullYear()
    }
  },
  methods: {
  },
  mounted() {
    
  },
}
</script>
<style scoped>
  .app-footer {
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: -0.02em;
    color: #9E9E9E;
    margin-top: auto;
    padding: 0.5rem 1rem;
  }

  a {
    color: #9E9E9E;
    text-decoration: none;
  }

  span {
    color: #d2d7e3;
  }

  a:hover {
    text-decoration: underline;
  }

  @media (min-width: 48rem) {
    .app-footer {
      padding: 0.5rem 0;
    }
  }
</style>